module.exports = __webpack_public_path__ + "img/sd1.e2a2efff.png";